export const COUNTRY_CODES: { code: string; name: string }[] = [
    { "code": "+1", "name": "United States" },
    { "code": "+91", "name": "India" },
    { "code": "+44", "name": "United Kingdom" },
    { "code": "+61", "name": "Australia" },
    { "code": "+81", "name": "Japan" },
    { "code": "+86", "name": "China" },
    { "code": "+49", "name": "Germany" },
    { "code": "+33", "name": "France" },
    { "code": "+39", "name": "Italy" },
    { "code": "+55", "name": "Brazil" },
    { "code": "+7", "name": "Russia" },
    { "code": "+971", "name": "United Arab Emirates" },
    { "code": "+27", "name": "South Africa" },
    { "code": "+82", "name": "South Korea" },
    { "code": "+34", "name": "Spain" },
    { "code": "+1", "name": "Canada" },
    { "code": "+65", "name": "Singapore" },
    { "code": "+60", "name": "Malaysia" },
    { "code": "+62", "name": "Indonesia" },
    { "code": "+966", "name": "Saudi Arabia" }
];

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const STD_TEST_OPTIONS = [
    { label: 'SAT', value: 'SAT' },
    { label: 'ACT', value: 'ACT' }
]

export const LANG_TEST_OPTIONS = [
    { label: 'TOEFL', value: 'TOEFL' },
    { label: 'IELTS', value: 'IELTS' }
]

export const MASTER_TEST_OPTIONS = [
    { label: 'GRE', value: 'GRE' },
    { label: 'GMAT', value: 'GMAT' }
]

export const DISCIPLINE_OPTIONS = [
    { label: 'Agricultural/Animal/Plant/Veterinary Science And Related Fields', value: '01' },
    { label: 'Natural Resources And Conservation', value: '03' },
    { label: 'Architecture And Related Services', value: '04' },
    { label: 'Area, Ethnic, Cultural, Gender, And Group Studies', value: '05' },
    { label: 'Communication, Journalism, And Related Programs', value: '09' },
    { label: 'Communications Technologies/Technicians And Support Services', value: '10' },
    { label: 'Computer And Information Sciences And Support Services', value: '11' },
    { label: 'Culinary, Entertainment, And Personal Services', value: '12' },
    { label: 'Education', value: '13' },
    { label: 'Engineering', value: '14' },
    { label: 'Engineering/Engineering-Related Technologies/Technicians', value: '15' },
    { label: 'Foreign Languages, Literatures, And Linguistics', value: '16' },
    { label: 'Family And Consumer Sciences/Human Sciences', value: '19' },
    { label: 'Legal Professions And Studies', value: '22' },
    { label: 'English Language And Literature/Letters', value: '23' },
    { label: 'Liberal Arts And Sciences, General Studies And Humanities', value: '24' },
    { label: 'Library Science', value: '25' },
    { label: 'Biological And Biomedical Sciences', value: '26' },
    { label: 'Mathematics And Statistics', value: '27' },
    { label: 'Military Science, Leadership And Operational Art', value: '28' },
    { label: 'Military Technologies And Applied Sciences', value: '29' },
    { label: 'Multi/Interdisciplinary Studies', value: '30' },
    { label: 'Parks, Recreation, Leisure, Fitness, And Kinesiology', value: '31' },
    { label: 'Basic Skills And Developmental/Remedial Education', value: '32' },
    { label: 'Citizenship Activities', value: '33' },
    { label: 'Health-Related Knowledge And Skills', value: '34' },
    { label: 'Interpersonal And Social Skills', value: '35' },
    { label: 'Leisure And Recreational Activities', value: '36' },
    { label: 'Personal Awareness And Self-Improvement', value: '37' },
    { label: 'Philosophy And Religious Studies', value: '38' },
    { label: 'Theology And Religious Vocations', value: '39' },
    { label: 'Physical Sciences', value: '40' },
    { label: 'Science Technologies/Technicians', value: '41' },
    { label: 'Psychology', value: '42' },
    { label: 'Homeland Security, Law Enforcement, Firefighting And Related Protective Services', value: '43' },
    { label: 'Public Administration And Social Service Professions', value: '44' },
    { label: 'Social Sciences', value: '45' },
    { label: 'export Construction Trades', value: '46' },
    { label: 'Mechanic And Repair Technologies/Technicians', value: '47' },
    { label: 'Precision Production', value: '48' },
    { label: 'Transportation And Materials Moving', value: '49' },
    { label: 'Visual And Performing Arts', value: '50' },
    { label: 'Health Professions And Related Programs', value: '51' },
    { label: 'Business, Management, Marketing, And Related Support Services', value: '52' },
    { label: 'High School/Secondary Diplomas And Certificates', value: '53' },
    { label: 'History', value: '54' },
    { label: 'Health Professions Residency/Fellowship Programs', value: '60' },
    { label: 'Medical Residency/Fellowship Programs', value: '61' }
]

export const HIGH_PRIORITIES_OPTIONS = [
    { label: "Earnings", value: "earnings" },
    { label: "Tuition Fee", value: "tuitionFee" },
    { label: "Employment", value: "employment" },
    { label: "Ranking", value: "ranking" },
    //{ label: "Academics", value: "academics" },
    //{ label: "Social Life", value: "socialLife" },
    { label: "Acceptance Rate", value: "acceptanceRate" },
]
export const TUITION_FEE_OPTIONS = ['No Limit', '$0 to $10,000', '$10,000 to $30,000', '$30,000 to $50,000', '$50,000+']
export const GPA_TOOLTIP = "In the USA, unweighted GPA is measured on a 4.0 scale, where all subjects are treated equally (A = 4.0, B = 3.0, etc.), while weighted GPA (on a 5.0 or 6.0 scale) gives extra points for advanced courses like AP or Honors. Undergraduate GPA refers to a student’s academic performance in a bachelor’s degree (B.Tech, B.Sc, B.Com, etc.), and is crucial for MS/MBA admissions and jobs. Graduate GPA applies to Master’s (MS, MBA) and PhD programs, where maintaining a minimum 3.0 GPA is often required for graduation. For Indian students, university CGPA or percentage is typically converted to a US GPA (4.0 scale), with an 8.0+ CGPA (~3.7+ GPA) being competitive for top universities."
export const DISCIPLINE_TOOLTIP = "In academics, discipline refers to a specific field of study or branch of knowledge that students choose based on their interests and career goals. Universities categorize courses under various disciplines such as Engineering, Medicine, Social Sciences, Humanities, and Business, each focusing on a distinct area of expertise. For example, Computer Science falls under Engineering & Technology, while Psychology belongs to Social Sciences. Choosing the right discipline involves considering personal interests, strengths, and future career opportunities. A well-chosen discipline helps students build expertise in a specific field, leading to better academic and professional success."

export const DEGREE_OPTIONS = [
  { value: "associate", label: "Associate" },
  { value: "bachelor", label: "Bachelor's" },
  { value: "master", label: "Master's" },
  { value: "doctorate", label: "Doctorate" },
]

export const YEAR_OF_PURSUE = [ '2026', '2027', '2028', '2029', '2030' ];

export const COUNTRY_OPTIONS = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
